import { useState, type FormEvent } from "react";

import { ApiError, apiClient } from "@shared/api";

interface PromoResponse {
  readonly code: string;
  readonly reward_currency: "primogem" | "star_glitter";
  readonly reward_amount: number;
}

export function PromoCodeForm(): JSX.Element {
  const [code, setCode] = useState("");
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    if (pending || !code.trim()) return;
    setPending(true);
    setMessage("");
    try {
      const result = await apiClient.post<PromoResponse, { code: string }>(
        "/promos/activate/",
        { body: { code } },
      );
      const currency = result.reward_currency === "primogem" ? "примогемов" : "звёздного блеска";
      setMessage(`Начислено ${result.reward_amount} ${currency}.`);
      setCode("");
    } catch (error) {
      setMessage(error instanceof ApiError ? error.message : "Не удалось активировать промокод.");
    } finally {
      setPending(false);
    }
  };

  return (
    <form onSubmit={(event) => void submit(event)}>
      <input
        value={code}
        onChange={(event) => setCode(event.target.value)}
        placeholder="Промокод"
        aria-label="Промокод"
        autoCapitalize="characters"
      />
      <button type="submit" disabled={pending || !code.trim()}>
        {pending ? "Активируем…" : "Активировать"}
      </button>
      {message ? <p role="status">{message}</p> : null}
    </form>
  );
}
